import {

  INDIVIDUAL_WORK_PLAN_FETCH_COMPLETED,
  INDIVIDUAL_WORK_PLAN_FETCH_STARTED,
  INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_COMPLETED,
  INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_STARTED,
  INDIVIDUAL_WORK_PLAN_I_FETCH_COMPLETED,
  DELETE_INDIVIDUAL_WORK_PLAN_I_COMPLETED,
  INDIVIDUAL_WORK_PLAN_III_FETCH_COMPLETED,
  INDIVIDUAL_WORK_PLAN_III_GROUP_FETCH_COMPLETED,
  NETWORK_REQUEST_SENT,
  INDIVIDUAL_WORK_PLAN_FILTER_FETCH_COMPLETED,
  INDIVIDUAL_WORK_PLAN_FILTER_FETCH_STARTED,
  INDIVIDUAL_WORK_PLAN_III_FETCH_COMPLETED_TIMES
} from "./types";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";
import { createNotification } from "../components/notifications/notifications";

export const getIndividualPlan = (state) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  const urlParams = new URLSearchParams(state).toString();
  if (getState().auth.token) {
    dispatch({ type: INDIVIDUAL_WORK_PLAN_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/individual_plans?${urlParams}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: INDIVIDUAL_WORK_PLAN_FETCH_COMPLETED,
        plan: result,
      });
    }
  }
};
export const getIndividualPlanFilters = (state) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  const urlParams = new URLSearchParams(state).toString();
  if (getState().auth.token) {
    dispatch({ type: INDIVIDUAL_WORK_PLAN_FILTER_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/individual_plans/filters`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: INDIVIDUAL_WORK_PLAN_FILTER_FETCH_COMPLETED,
        plan: result,
      });
    }
  }
};

// ЗАКЛАДКИ
export const getIndividualPlanMain = (id) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/individual_plans/${id}/main`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_COMPLETED,
        plan: result,
      });
    }
  }
};
export const getIndividualPlanI = (id) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/individual_plans/${id}/I`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: INDIVIDUAL_WORK_PLAN_I_FETCH_COMPLETED,
        plan: result,
      });
    }
  }
};
export const addIndividualPlanI = (formData, id) =>
  async (dispatch, getState) => {
    // dispatch({ type: NEW_ORDER_REQUEST_STARTED });
    const url = `${BACKEND_URL_PREFIX}/individual_plans/${id}/I`;
    const response = await fetch(`${url}`, {
      method: 'POST',
      body: JSON.stringify(formData),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: INDIVIDUAL_WORK_PLAN_I_FETCH_COMPLETED, data: result });
      dispatch(getIndividualPlanI(id));
    } else {
      // dispatch({ type: NEW_ORDER_REQUEST_ERROR });
    }
  };
export const editIndividualPlanI = ({ ip_id, id, ...data }) =>
  async (dispatch, getState) => {
    // dispatch({ type: NEW_ORDER_REQUEST_STARTED });
    const url = `${BACKEND_URL_PREFIX}/individual_plans/${ip_id}/I/${id}`;
    const response = await fetch(`${url}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const result = await response.json();
      dispatch(getIndividualPlanI(ip_id));
    } else {
      // dispatch({ type: NEW_ORDER_REQUEST_ERROR });
    }
  };
export const deleteIndividualPlanI = (conf, data) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    // dispatch({ type: DELETE_LESSON_HOMEWORK_FILE_STARTED });

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/individual_plans/${data.ip_id}/I/${conf}`,
      {
        ...buildDefaultHeaders(getState),
        method: "delete",
      }
    );

    if (response.ok) {
      const result = await response.json();
      dispatch(getIndividualPlanI(data.ip_id));
    } else {
      // dispatch({ type: DELETE_LESSON_HOMEWORK_FILE_FAILED });
    }
  }
};
export const getIndividualPlanII = (id) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/individual_plans/${id}/II`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_COMPLETED, ///TODO
        plan: result,
      });
    }
  }
};
export const getIndividualPlanIII = ({ id, mid, xp_key }) => async (
  dispatch,
  getState
) => {
  console.log(id, mid, xp_key, 'id, mid, xp_key')
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/individual_plans/${id}/${mid}/${xp_key}/III`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: INDIVIDUAL_WORK_PLAN_III_FETCH_COMPLETED,
        plan: result,
      });
    }
  }
};

export const getIndividualPlanIIITimes = ({ id, mid, xp_key }) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/individual_plans/${id}/${mid}/${xp_key}/III/times`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: INDIVIDUAL_WORK_PLAN_III_FETCH_COMPLETED_TIMES,
        plan: result,
      });
    }
  }
};

export const getIndividualPlanIIIGroup = (id) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/individual_plans/${id}/group`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type: INDIVIDUAL_WORK_PLAN_III_GROUP_FETCH_COMPLETED,
        plan: result,
      });
    }
  }
};
export const editIndividualPlanIII = ({ kid, ip_id, mid, xp_key, ...data }) =>
  async (dispatch, getState) => {
    // dispatch({ type: NEW_ORDER_REQUEST_STARTED });
    const url = `${BACKEND_URL_PREFIX}/individual_plans/III_IV_V_VI_VII/${kid}/${ip_id}`;
    const response = await fetch(`${url}`, {
      method: 'PUT',
      body: JSON.stringify(data.data),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const result = await response.json();
      dispatch(getIndividualPlanIII({ id: ip_id, mid, xp_key }));
    } else {
      // dispatch({ type: NEW_ORDER_REQUEST_ERROR });
    }
  };